
  export enum Owners {
    SILVERGOLD = "SILVERGOLD",
    INVERMONEDA = "INVERMONEDA",
    PATRIMONIO_METALES = "PATRIMONIO_METALES",
    CLIENT = "CLIENT",
    CONTRACT = "CONTRACT"
  }
  